var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        "close-on-content-click": false,
        disabled: _vm.disabled,
        "content-class": _vm.menuContentClass
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "button",
                _vm._g(
                  { staticClass: "tbl-btn", attrs: { disabled: _vm.disabled } },
                  on
                ),
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    },
                    [
                      _c("path", {
                        attrs: { d: "M3 4h18l-7 8.5V20l-4-2v-5.5L3 4z" }
                      })
                    ]
                  ),
                  _vm._v("\n      Filter\n      "),
                  _vm.appliedFilterCount
                    ? _c("span", { staticClass: "tbl-btn-badge" }, [
                        _vm._v(_vm._s(_vm.appliedFilterCount))
                      ])
                    : _vm._e()
                ]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.showDropdown,
        callback: function($$v) {
          _vm.showDropdown = $$v
        },
        expression: "showDropdown"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        {
          staticClass: "k-sort-filter-menu sb-table-popup-menu",
          attrs: { subheader: "" }
        },
        [
          _c("v-subheader", [_vm._v("Filter Controls:")]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.showFiltersClass,
                  attrs: { flat: "", color: "info", disabled: _vm.isOrApplied },
                  on: { mousedown: _vm.handleShowFiltersClick }
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass:
                            "mr-3 vertical-align-middle visibility-icon",
                          attrs: { size: 14 }
                        },
                        [_vm._v("visibility")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Show filters")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  class: _vm.hideFiltersClass,
                  attrs: { flat: "", color: "info", disabled: _vm.isOrApplied },
                  on: { mousedown: _vm.handleHideFiltersClick }
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass:
                            "mr-3 vertical-align-middle visibility-icon",
                          attrs: { size: 14 }
                        },
                        [_vm._v("visibility_off")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Hide filters")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "k-operation-check-icon",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("check")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.showAdvancedFilter
                ? _c(
                    "v-btn",
                    {
                      staticClass: "k-filter-menu-item active",
                      attrs: { flat: "", color: "info" },
                      on: { mousedown: _vm.handleApplyFilters }
                    },
                    [
                      _c(
                        "span",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-3 vertical-align-middle",
                              attrs: { size: 14 }
                            },
                            [_vm._v("filter_alt")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Advanced Filters")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.appliedFilterCount
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "k-operation-check-icon",
                              attrs: { color: "primary" }
                            },
                            [_vm._v("check")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", {
            staticStyle: { "margin-top": "4px", "margin-bottom": "2px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  staticClass: "k-filter-menu-item k-error-menu-item",
                  attrs: { flat: "", color: "error" },
                  on: { mousedown: _vm.handleClearAllClick }
                },
                [_vm._v("\n        Clear all\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }